import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useIsLoggedIn } from '../../features/auth/hooks';
import { useInvitesActions } from '../../features/invites/hooks/useInvitesActions';
import { usePendingGiftCode } from '../../features/invites/hooks/useInvitesState';
import { Modal, Flex, Typo, Button } from '../../ui';
import { useTranslation } from 'react-i18next';

const GiftCodeHandler = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isLoggedIn = useIsLoggedIn();
  const { acceptInvitation, setPendingGiftCode } = useInvitesActions();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const pendingGiftCode = usePendingGiftCode();

  useEffect(() => {
    if (isLoggedIn && pendingGiftCode) {
      const code = pendingGiftCode;
      setPendingGiftCode(null);
      acceptInvitation({ giftCode: code })
        .then((result) => {
          if (result?.errorCode) {
            setPendingGiftCode(code);
            setShowErrorModal(true);
          }
        })
        .catch(() => {
          setPendingGiftCode(code);
          setShowErrorModal(true);
        });
    }
  }, [isLoggedIn, pendingGiftCode, acceptInvitation, setPendingGiftCode]);

  if (!showErrorModal) {
    return null;
  }

  return (
    <Modal
      open={showErrorModal}
      onClose={() => setShowErrorModal(false)}
      title={t('gift.acceptFailed')}
      showActions={true}
      onAccept={() => {
        setShowErrorModal(false);
        navigate('/profile/gift');
      }}
      acceptLabel={t('gift.goToProfile')}
    >
      <Flex direction='column' gap='10'>
        <Typo.Text>{t('gift.acceptFailedMessage')}</Typo.Text>
        <Typo.Text>{t('gift.acceptManually')}</Typo.Text>
      </Flex>
    </Modal>
  );
};

export default GiftCodeHandler;

